module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "item",
    staticClass: "vue-grid-item",
    class: {
      'vue-resizable': _vm.resizable,
      'resizing': _vm.isResizing,
      'vue-draggable-dragging': _vm.isDragging,
      'cssTransforms': _vm.useCssTransforms,
      'disable-userselect': _vm.isDragging
    },
    style: (_vm.style)
  }, [(_vm.$slots['header']) ? _c('div', {
    staticClass: "grid-item-header level"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [(_vm.model && _vm.schema) ? _c('font-awesome-icon', {
    staticClass: "facet-control",
    attrs: {
      "icon": "list",
      "size": "xs"
    },
    on: {
      "click": function($event) {
        _vm.showModal()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isDraggable) ? _c('font-awesome-icon', {
    staticClass: "facet-control-move facet-control",
    attrs: {
      "icon": "arrows-alt",
      "size": "xs"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.model.maximizable) ? _c('font-awesome-icon', {
    staticClass: "facet-control",
    attrs: {
      "icon": "expand-arrows-alt",
      "size": "xs"
    },
    on: {
      "click": function($event) {
        _vm.expandItem(_vm.id)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.model.removeable) ? _c('font-awesome-icon', {
    staticClass: "facet-control",
    attrs: {
      "icon": "times-circle",
      "size": "xs"
    },
    on: {
      "click": function($event) {
        _vm.removeItem(_vm.id)
      }
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('div', {}, [(_vm.$slots['body-left']) ? _c('div', {
    staticClass: "grid-item-body-left column"
  }, [_vm._t("body-left", null, {
    $ref: "body-left"
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('div', [_vm._t("default"), _vm._v(" "), (_vm.$slots['body-bottom']) ? _c('div', [_vm._t("body-bottom")], 2) : _vm._e()], 2)]), _vm._v(" "), (_vm.$slots['body-right']) ? _c('div', {
    staticClass: "grid-item-body-right"
  }, [_vm._t("body-right")], 2) : _vm._e()])]), _vm._v(" "), (_vm.$slots['footer']) ? _c('div', {
    staticClass: "grid-item-footer"
  }, [_vm._t("footer")], 2) : _vm._e(), _vm._v(" "), (_vm.isResizable) ? _c('span', {
    ref: "handle",
    class: _vm.resizableHandleClass
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-180a38f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GridItem.vue
// module id = 77
// module chunks = 0